"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Styles defined by our product designers
// https://kyruus.jira.com/wiki/spaces/product/pages/366313696/UI+Theme
const PROVIDERMATCH_BLUE = '#087DB9';
const PROVIDERMATCH_BLUE_SECONDARY = '#D4D8DC';
const KYRUUS_BLUE = '#00B3E6';
const UNIFIED_NAV_BLUE = '#23315d';
const UNIFIED_NAV_SECONDARY = '#4671a9';
const UNIFIED_NAV_TERTIARY = '#7ac0b7';
const BLUE_1 = '#055B85';
const BLUE_2 = '#9CD5F2';
const BLUE_3 = '#E6F4FB';
const BLUE_4 = '#2A3D51';
const CYAN_CONTRAST_HOVER = '#6CEAD7';
const PURPLE_1 = '#7570B3';
const GREEN_2 = '#408500';
const GREEN_5 = '#96C966';
const GREEN_CONTRAST_HOVER = '#306301';
const GREEN_ICON = '#4FA500';
const GRAY_1 = '#2A3D51';
const GRAY_2 = '#667382';
const GRAY_3 = '#D4D8DC';
const GRAY_4 = '#E9EBED';
const GRAY_5 = '#F6F7F8';
const GRAY_6 = PROVIDERMATCH_BLUE_SECONDARY;
const GRAY_7 = '#F5F5F5';
const WHITE = '#FFFFFF';
const RED_CONTRAST_HOVER = '#9C242E';
const YELLOW_HOVER = '#D28518';
const COLOR_SUCCESS = '#408500';
const COLOR_SUCCESS_SECONDARY = '#EDF6E5';
const COLOR_INFO = BLUE_1;
const COLOR_INFO_SECONDARY = BLUE_3;
const COLOR_WARNING = '#F0AD4E';
const COLOR_WARNING_SECONDARY = '#FDF6ED';
const COLOR_DANGER = '#D02937';
const COLOR_DANGER_SECONDARY = '#F9DBDE';
const COLOR_STAR_RATINGS = '#F0AD4E';
const UNIFIED_NAV_WIDTH = '256px';
var _default = exports.default = {
  /** Colors */
  // Branding
  color_providermatch: PROVIDERMATCH_BLUE,
  color_providermatch_secondary: PROVIDERMATCH_BLUE_SECONDARY,
  color_providermatch_tertiary: PROVIDERMATCH_BLUE_SECONDARY,
  color_providermatch_quaternary: PROVIDERMATCH_BLUE_SECONDARY,
  color_kyruus: KYRUUS_BLUE,
  // unified nav v2
  color_unified_nav_primary: UNIFIED_NAV_BLUE,
  color_unified_nav_secondary: UNIFIED_NAV_SECONDARY,
  unified_nav_width: UNIFIED_NAV_WIDTH,
  color_unified_nav_tertiary: UNIFIED_NAV_TERTIARY,
  // Actions
  color_success: COLOR_SUCCESS,
  color_success_secondary: COLOR_SUCCESS_SECONDARY,
  color_info: COLOR_INFO,
  color_info_secondary: COLOR_INFO_SECONDARY,
  color_warning: COLOR_WARNING,
  color_warning_secondary: COLOR_WARNING_SECONDARY,
  color_danger: COLOR_DANGER,
  color_danger_secondary: COLOR_DANGER_SECONDARY,
  // Accents
  color_accent_purple: PURPLE_1,
  // Backgrounds
  color_background: WHITE,
  color_background_hover: GRAY_3,
  color_background_badge: PROVIDERMATCH_BLUE_SECONDARY,
  color_background_secondary: GRAY_7,
  color_background_disabled_form_input: GRAY_4,
  color_background_info: BLUE_3,
  color_background_warning: COLOR_WARNING_SECONDARY,
  color_background_danger: COLOR_DANGER_SECONDARY,
  color_background_success: COLOR_SUCCESS_SECONDARY,
  // Text
  color_text: GRAY_1,
  color_text_secondary: GRAY_2,
  color_text_contrast: WHITE,
  color_text_disabled: GRAY_6,
  color_text_placeholder: GRAY_2,
  color_link: PROVIDERMATCH_BLUE,
  color_link_hover: BLUE_1,
  color_link_contrast: BLUE_2,
  color_text_button_disabled: GRAY_2,
  // Borders
  color_border: GRAY_3,
  color_border_emphasis: GRAY_1,
  color_border_disabled: GRAY_6,
  color_border_info: BLUE_1,
  color_border_secondary: GRAY_2,
  color_border_warning: COLOR_WARNING,
  color_border_danger: COLOR_DANGER,
  color_border_success: COLOR_SUCCESS,
  // Colors for placeholders and skeleton elements
  color_background_skeleton: GRAY_3,
  color_checkbox: GRAY_3,
  color_checkbox_disabled: GRAY_3,
  color_image_placeholder: GRAY_3,
  // Item selection
  color_item_hover: GRAY_4,
  color_contrast_green_hover: GREEN_CONTRAST_HOVER,
  color_contrast_red_hover: RED_CONTRAST_HOVER,
  color_contrast_cyan_hover: CYAN_CONTRAST_HOVER,
  color_yellow_hover: YELLOW_HOVER,
  // Buttons
  color_button: PROVIDERMATCH_BLUE,
  color_button_hover: BLUE_1,
  color_button_disabled: GRAY_5,
  color_button_active: BLUE_4,
  color_button_secondary: GRAY_5,
  color_button_secondary_hover: GRAY_3,
  color_button_secondary_disabled: GRAY_5,
  color_button_flat_hover: BLUE_3,
  // Star ratings
  color_star_ratings: COLOR_STAR_RATINGS,
  // Icons
  color_icon_green: GREEN_ICON,
  // Switches
  // TODO: Use constants once we have new colors
  color_switch_on: COLOR_SUCCESS,
  color_switch_on_secondary: GREEN_5,
  color_switch_on_label: GREEN_2,
  color_switch_off: WHITE,
  color_switch_off_secondary: '#B1BAC4',
  color_switch_disabled: GRAY_4,
  color_switch_disabled_secondary: PROVIDERMATCH_BLUE_SECONDARY,
  /** Fonts */
  // Font face
  font_face: 'Helvetica Neue, Helvetica, Arial, sans-serif',
  // Font weights
  font_weight: 400,
  font_weight_bold: 500,
  font_weight_light: 300,
  font_weight_bolder: 700,
  // Font size
  font_size_small: '12px',
  font_size: '14px',
  font_size_large: '16px',
  font_size_heading_5: '16px',
  font_size_heading_4: '20px',
  font_size_heading_3: '24px',
  font_size_heading_2: '30px',
  font_size_heading_1: '36px',
  // Line height
  font_line_height: 1.428571429,
  /** Spacing */
  spacing_xsmall: '4px',
  spacing_small: '8px',
  spacing_medium: '16px',
  spacing_large: '24px',
  spacing_xlarge: '32px',
  spacing_xxlarge: '48px',
  /** Borders */

  // Border radius
  border_radius: '2px',
  border_radius_medium: '6px',
  border_radius_floating_button: '30px',
  border_radius_chip: '2rem',
  border_radius_badge_chip: '16px',
  border_radius_rounded: '100px',
  // Border style
  border_style: 'solid',
  // Border width
  border_width: '1px',
  /** Screen sizes */
  screen_small: '480px',
  screen_medium: '768px',
  screen_large: '1140px',
  /** Screen sizes for DirectBook Widget */
  db_screen_xsmall: '420px',
  db_screen_small: '768px',
  db_screen_medium: '992px',
  db_screen_large: '1200px',
  /** Box shadow */
  initial_box_shadow: 'initial',
  box_shadow_floating_button: '0 4px 10px rgba(0, 0, 0, 0.5)'
};